import Swiper, {
  Navigation, Pagination, Lazy, A11y,
} from 'swiper';
import $ from 'jquery';
import { breakpoints } from 'js/config/breakpoints';

const slider = '.js-slider-box';
const sliderMainWrap = '.js-swiper-main-wrap';
const nextSlideNavEl = '.swiper-button-next';
const prevSlideNavEl = '.swiper-button-prev';
const slideNavBlock = '.swiper__navigate-block';
const pagination = '.swiper-pagination';

function toggleNavigationView($slider) {
  const swiperDisabledClass = 'swiper-button-disabled';
  const mainWrap = $slider.closest(sliderMainWrap);
  const navBlock = mainWrap.find(slideNavBlock);
  const prevButton = navBlock.find(prevSlideNavEl);
  const nextButton = navBlock.find(nextSlideNavEl);
  if (prevButton.hasClass(swiperDisabledClass) && nextButton.hasClass(swiperDisabledClass)) {
    navBlock.hide();
  } else {
    navBlock.show();
  }
}

function initSlider($slider) {
  const swiper = new Swiper($slider[0], {
    modules: [Navigation, Pagination, Lazy, A11y],
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      preloaderClass: 'swiper__preloader',
    },
    loop: true,
    init: false,
    freeMode: true,
    spaceBetween: 0,
    centeredSlides: false,
    slidesPerView: 1,
    keyboard: true,
    pagination: {
      el: $slider.closest(sliderMainWrap).find(pagination)[0],
      clickable: true,
      renderBullet: (index, className) => `<button class="${className}" aria-label="Go to slide ${index}"></button>`,
    },
    navigation: {
      nextEl: $slider.closest(sliderMainWrap).find(nextSlideNavEl)[0],
      prevEl: $slider.closest(sliderMainWrap).find(prevSlideNavEl)[0],
    },
    on: {
      transitionEnd: () => {
        $(document).trigger('slider-transition-end', {
          slider: this,
        });
      },
      resize: () => {
        toggleNavigationView($slider);
      },
      paginationRender: () => {
        $slider.find('.swiper-pagination-bullet').each(function (index) {
          const bullet = $(this);
          bullet.attr('id', (index));
        });

        $slider.find('.swiper-pagination').each(() => {
          $slider.find('.swiper-pagination-bullet').attr('tabindex', 0);
          $slider.find('.swiper-pagination-bullet').on('keydown', function (event) {
            if (event.keyCode === 13) {
              const slideID = $(this).attr('id');
              swiper.slideToLoop(slideID);
            }
          });
        });
      },
      slideChangeTransitionEnd: () => {
        const caption = $slider.find('.swiper-slide-active .slider-box__block-caption').html();
        $slider.closest(sliderMainWrap).find('.swiper-caption').html(caption);
      },
    },
    breakpoints: {
      768: {
        freeMode: true,
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        freeMode: false,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1380: {
        freeMode: false,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  });

  swiper.init();
  toggleNavigationView($slider);
}

function setMaxHeight() {
  const sliderImages = document.querySelectorAll('.slider-box__block-img-wrap');

  if (window.innerWidth < breakpoints.lg || window.innerWidth > breakpoints.xl) {
    sliderImages.forEach((sliderImage) => {
      sliderImage.style.removeProperty('max-height');
    });

    return;
  }

  const adminEnabled = document.getElementById('wpadminbar')?.getBoundingClientRect().height ?? 0;
  const headerHeight = document.querySelector('.header-container')?.getBoundingClientRect().height ?? 0;
  const galleryHeight = document.querySelector('.container.gallery')?.getBoundingClientRect().height ?? 0;
  const galleryListWrapper = document.querySelector('.gallery__list-wrapper').getBoundingClientRect().height ?? 0;
  const swiperPagination = document.querySelector('.swiper-pagination-wrap').getBoundingClientRect().height ?? 0;
  const summaryHeight = adminEnabled + headerHeight + galleryHeight + galleryListWrapper;

  sliderImages.forEach((sliderImage) => {
    const el = sliderImage;
    el.style.maxHeight = `calc(100dvh - ${summaryHeight + swiperPagination + 16}px)`;
  });
}

$(document).ready(() => {
  if ($(slider).length) {
    $(slider).each(function () {
      initSlider($(this));
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  setMaxHeight();
});
document.addEventListener('resize', () => {
  setMaxHeight();
});
